import {ExceedsNonPrimaryVolumeStatisticsSnapshot} from "../../../model/exceeds-non-primary-volume-statistics-snapshot";
import {otsBaseApi} from "../../ots-api";
import {
  ExceedsNonPrimaryVolumeStatisticsSearchCriteria
} from "../../../model/search/exceeds-non-primary-volume-statistics-search-criteria";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ExceedsNonPrimaryVolumeStatistics"]});

export const exceedsNonPrimaryVolumeStatisticsApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchExceedsNonPrimaryVolumeStatistics: builder.query<ExceedsNonPrimaryVolumeStatisticsSnapshot[], ExceedsNonPrimaryVolumeStatisticsSearchCriteria>({
      query: (arg) => ({
        url: `/statistics/exceeds-non-primary-volume/search`,
        method: "POST",
        body: arg
      }),
      providesTags: (result, _error, arg, _meta) => {
        return [{type: "ExceedsNonPrimaryVolumeStatistics", id: "LIST"}];
      },
    }),
  })
});

export const {
  useSearchExceedsNonPrimaryVolumeStatisticsQuery,
} = exceedsNonPrimaryVolumeStatisticsApi;
